import { Typography, Alert } from '@mui/material';
import PublicToolLayout from '../../components/public-tools/PublicToolLayout';
import ToolWidget from '../../components/public-tools/ToolWidget';

export default function AiCrawlingReadinessPage() {
  return (
    <PublicToolLayout title="AI Search Readiness">
      <Typography variant="h5" fontWeight={700} gutterBottom>
        AI Search Readiness Check
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Check whether AI crawlers (GPTBot, ClaudeBot, PerplexityBot, and others) can access your
        website, and whether your content has the entity signals and structure that may help AI
        systems discover and cite it.
      </Typography>
      <Alert severity="info" sx={{ mb: 3 }} icon={false}>
        Results show <strong>AI readiness signals</strong> only — not a guarantee of inclusion in
        any AI system's index or responses.
      </Alert>
      <ToolWidget
        scanType="AI_CRAWLING"
        formLabel="Website or page URL"
        formPlaceholder="https://example.com"
      />
    </PublicToolLayout>
  );
}
